import React from 'react';
import Page from './../Core/Page';
import { PageSection } from '../../Layout';
import AdvancedSearch from '../../../Components/Search/AdvancedSearch';
import FilterSearch from '../../../Components/Search/FilterSearch';
import './SearchPage.scss';

const SearchPage = () => {
  return (
    <Page heading="Search">
      <PageSection>
        <div className="SearchPage-Section">
          <div className="SearchPage-Content">
            <div className="SearchPage-Filter">
              <FilterSearch />
            </div>
            <div className="SearchPage-Search">
              <AdvancedSearch />
            </div>
          </div>
        </div>
      </PageSection>
    </Page>
  );
};

export default SearchPage;
